var L = typeof global == "object" && global && global.Object === Object && global, U = typeof self == "object" && self && self.Object === Object && self, y = L || U || Function("return this")(), f = y.Symbol, R = Object.prototype, G = R.hasOwnProperty, W = R.toString, d = f ? f.toStringTag : void 0;
function K(e) {
  var t = G.call(e, d), r = e[d];
  try {
    e[d] = void 0;
    var n = !0;
  } catch {
  }
  var a = W.call(e);
  return n && (t ? e[d] = r : delete e[d]), a;
}
var Z = Object.prototype, J = Z.toString;
function Y(e) {
  return J.call(e);
}
var B = "[object Null]", X = "[object Undefined]", j = f ? f.toStringTag : void 0;
function z(e) {
  return e == null ? e === void 0 ? X : B : j && j in Object(e) ? K(e) : Y(e);
}
function k(e) {
  return e != null && typeof e == "object";
}
var q = "[object Symbol]";
function _(e) {
  return typeof e == "symbol" || k(e) && z(e) == q;
}
function V(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, a = Array(n); ++r < n; )
    a[r] = t(e[r], r, e);
  return a;
}
var T = Array.isArray, P = f ? f.prototype : void 0, w = P ? P.toString : void 0;
function N(e) {
  if (typeof e == "string")
    return e;
  if (T(e))
    return V(e, N) + "";
  if (_(e))
    return w ? w.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var Q = /\s/;
function ee(e) {
  for (var t = e.length; t-- && Q.test(e.charAt(t)); )
    ;
  return t;
}
var te = /^\s+/;
function re(e) {
  return e && e.slice(0, ee(e) + 1).replace(te, "");
}
function x(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var $ = NaN, ne = /^[-+]0x[0-9a-f]+$/i, ae = /^0b[01]+$/i, ue = /^0o[0-7]+$/i, oe = parseInt;
function D(e) {
  if (typeof e == "number")
    return e;
  if (_(e))
    return $;
  if (x(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = x(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = re(e);
  var r = ae.test(e);
  return r || ue.test(e) ? oe(e.slice(2), r ? 2 : 8) : ne.test(e) ? $ : +e;
}
var ie = 1 / 0, ce = 17976931348623157e292;
function fe(e) {
  if (!e)
    return e === 0 ? e : 0;
  if (e = D(e), e === ie || e === -1 / 0) {
    var t = e < 0 ? -1 : 1;
    return t * ce;
  }
  return e === e ? e : 0;
}
function se(e) {
  var t = fe(e), r = t % 1;
  return t === t ? r ? t - r : t : 0;
}
var he = "[object AsyncFunction]", de = "[object Function]", pe = "[object GeneratorFunction]", le = "[object Proxy]";
function ge(e) {
  if (!x(e))
    return !1;
  var t = z(e);
  return t == de || t == pe || t == he || t == le;
}
var C = y["__core-js_shared__"], A = function() {
  var e = /[^.]+$/.exec(C && C.keys && C.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function xe(e) {
  return !!A && A in e;
}
var ye = Function.prototype, _e = ye.toString;
function be(e) {
  if (e != null) {
    try {
      return _e.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var me = /[\\^$.*+?()[\]{}|]/g, ve = /^\[object .+?Constructor\]$/, Se = Function.prototype, Oe = Object.prototype, Ce = Se.toString, Ie = Oe.hasOwnProperty, Te = RegExp(
  "^" + Ce.call(Ie).replace(me, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Ee(e) {
  if (!x(e) || xe(e))
    return !1;
  var t = ge(e) ? Te : ve;
  return t.test(be(e));
}
function je(e, t) {
  return e == null ? void 0 : e[t];
}
function M(e, t) {
  var r = je(e, t);
  return Ee(r) ? r : void 0;
}
function Pe(e, t) {
  return e === t || e !== e && t !== t;
}
var we = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $e = /^\w*$/;
function Ae(e, t) {
  if (T(e))
    return !1;
  var r = typeof e;
  return r == "number" || r == "symbol" || r == "boolean" || e == null || _(e) ? !0 : $e.test(e) || !we.test(e) || t != null && e in Object(t);
}
var p = M(Object, "create");
function Re() {
  this.__data__ = p ? p(null) : {}, this.size = 0;
}
function ze(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var Ne = "__lodash_hash_undefined__", De = Object.prototype, Me = De.hasOwnProperty;
function Fe(e) {
  var t = this.__data__;
  if (p) {
    var r = t[e];
    return r === Ne ? void 0 : r;
  }
  return Me.call(t, e) ? t[e] : void 0;
}
var He = Object.prototype, Le = He.hasOwnProperty;
function Ue(e) {
  var t = this.__data__;
  return p ? t[e] !== void 0 : Le.call(t, e);
}
var Ge = "__lodash_hash_undefined__";
function We(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = p && t === void 0 ? Ge : t, this;
}
function i(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
i.prototype.clear = Re;
i.prototype.delete = ze;
i.prototype.get = Fe;
i.prototype.has = Ue;
i.prototype.set = We;
function Ke() {
  this.__data__ = [], this.size = 0;
}
function b(e, t) {
  for (var r = e.length; r--; )
    if (Pe(e[r][0], t))
      return r;
  return -1;
}
var Ze = Array.prototype, Je = Ze.splice;
function Ye(e) {
  var t = this.__data__, r = b(t, e);
  if (r < 0)
    return !1;
  var n = t.length - 1;
  return r == n ? t.pop() : Je.call(t, r, 1), --this.size, !0;
}
function Be(e) {
  var t = this.__data__, r = b(t, e);
  return r < 0 ? void 0 : t[r][1];
}
function Xe(e) {
  return b(this.__data__, e) > -1;
}
function ke(e, t) {
  var r = this.__data__, n = b(r, e);
  return n < 0 ? (++this.size, r.push([e, t])) : r[n][1] = t, this;
}
function s(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
s.prototype.clear = Ke;
s.prototype.delete = Ye;
s.prototype.get = Be;
s.prototype.has = Xe;
s.prototype.set = ke;
var qe = M(y, "Map");
function Ve() {
  this.size = 0, this.__data__ = {
    hash: new i(),
    map: new (qe || s)(),
    string: new i()
  };
}
function Qe(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function m(e, t) {
  var r = e.__data__;
  return Qe(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
function et(e) {
  var t = m(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function tt(e) {
  return m(this, e).get(e);
}
function rt(e) {
  return m(this, e).has(e);
}
function nt(e, t) {
  var r = m(this, e), n = r.size;
  return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
}
function c(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
c.prototype.clear = Ve;
c.prototype.delete = et;
c.prototype.get = tt;
c.prototype.has = rt;
c.prototype.set = nt;
var at = "Expected a function";
function v(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(at);
  var r = function() {
    var n = arguments, a = t ? t.apply(this, n) : n[0], o = r.cache;
    if (o.has(a))
      return o.get(a);
    var u = e.apply(this, n);
    return r.cache = o.set(a, u) || o, u;
  };
  return r.cache = new (v.Cache || c)(), r;
}
v.Cache = c;
var ut = 500;
function ot(e) {
  var t = v(e, function(n) {
    return r.size === ut && r.clear(), n;
  }), r = t.cache;
  return t;
}
var it = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, ct = /\\(\\)?/g, ft = ot(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(it, function(r, n, a, o) {
    t.push(a ? o.replace(ct, "$1") : n || r);
  }), t;
});
function l(e) {
  return e == null ? "" : N(e);
}
function st(e, t) {
  return T(e) ? e : Ae(e, t) ? [e] : ft(l(e));
}
function ht(e) {
  if (typeof e == "string" || _(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
function dt(e, t) {
  t = st(t, e);
  for (var r = 0, n = t.length; e != null && r < n; )
    e = e[ht(t[r++])];
  return r && r == n ? e : void 0;
}
function I(e, t, r) {
  var n = e == null ? void 0 : dt(e, t);
  return n === void 0 ? r : n;
}
function pt(e) {
  return function(t) {
    return e == null ? void 0 : e[t];
  };
}
var lt = {
  // Latin-1 Supplement block.
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  Å: "A",
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ä: "a",
  å: "a",
  Ç: "C",
  ç: "c",
  Ð: "D",
  ð: "d",
  È: "E",
  É: "E",
  Ê: "E",
  Ë: "E",
  è: "e",
  é: "e",
  ê: "e",
  ë: "e",
  Ì: "I",
  Í: "I",
  Î: "I",
  Ï: "I",
  ì: "i",
  í: "i",
  î: "i",
  ï: "i",
  Ñ: "N",
  ñ: "n",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  Ø: "O",
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  ø: "o",
  Ù: "U",
  Ú: "U",
  Û: "U",
  Ü: "U",
  ù: "u",
  ú: "u",
  û: "u",
  ü: "u",
  Ý: "Y",
  ý: "y",
  ÿ: "y",
  Æ: "Ae",
  æ: "ae",
  Þ: "Th",
  þ: "th",
  ß: "ss",
  // Latin Extended-A block.
  Ā: "A",
  Ă: "A",
  Ą: "A",
  ā: "a",
  ă: "a",
  ą: "a",
  Ć: "C",
  Ĉ: "C",
  Ċ: "C",
  Č: "C",
  ć: "c",
  ĉ: "c",
  ċ: "c",
  č: "c",
  Ď: "D",
  Đ: "D",
  ď: "d",
  đ: "d",
  Ē: "E",
  Ĕ: "E",
  Ė: "E",
  Ę: "E",
  Ě: "E",
  ē: "e",
  ĕ: "e",
  ė: "e",
  ę: "e",
  ě: "e",
  Ĝ: "G",
  Ğ: "G",
  Ġ: "G",
  Ģ: "G",
  ĝ: "g",
  ğ: "g",
  ġ: "g",
  ģ: "g",
  Ĥ: "H",
  Ħ: "H",
  ĥ: "h",
  ħ: "h",
  Ĩ: "I",
  Ī: "I",
  Ĭ: "I",
  Į: "I",
  İ: "I",
  ĩ: "i",
  ī: "i",
  ĭ: "i",
  į: "i",
  ı: "i",
  Ĵ: "J",
  ĵ: "j",
  Ķ: "K",
  ķ: "k",
  ĸ: "k",
  Ĺ: "L",
  Ļ: "L",
  Ľ: "L",
  Ŀ: "L",
  Ł: "L",
  ĺ: "l",
  ļ: "l",
  ľ: "l",
  ŀ: "l",
  ł: "l",
  Ń: "N",
  Ņ: "N",
  Ň: "N",
  Ŋ: "N",
  ń: "n",
  ņ: "n",
  ň: "n",
  ŋ: "n",
  Ō: "O",
  Ŏ: "O",
  Ő: "O",
  ō: "o",
  ŏ: "o",
  ő: "o",
  Ŕ: "R",
  Ŗ: "R",
  Ř: "R",
  ŕ: "r",
  ŗ: "r",
  ř: "r",
  Ś: "S",
  Ŝ: "S",
  Ş: "S",
  Š: "S",
  ś: "s",
  ŝ: "s",
  ş: "s",
  š: "s",
  Ţ: "T",
  Ť: "T",
  Ŧ: "T",
  ţ: "t",
  ť: "t",
  ŧ: "t",
  Ũ: "U",
  Ū: "U",
  Ŭ: "U",
  Ů: "U",
  Ű: "U",
  Ų: "U",
  ũ: "u",
  ū: "u",
  ŭ: "u",
  ů: "u",
  ű: "u",
  ų: "u",
  Ŵ: "W",
  ŵ: "w",
  Ŷ: "Y",
  ŷ: "y",
  Ÿ: "Y",
  Ź: "Z",
  Ż: "Z",
  Ž: "Z",
  ź: "z",
  ż: "z",
  ž: "z",
  Ĳ: "IJ",
  ĳ: "ij",
  Œ: "Oe",
  œ: "oe",
  ŉ: "'n",
  ſ: "s"
}, gt = pt(lt), xt = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, yt = "\\u0300-\\u036f", _t = "\\ufe20-\\ufe2f", bt = "\\u20d0-\\u20ff", mt = yt + _t + bt, vt = "[" + mt + "]", St = RegExp(vt, "g");
function Ot(e) {
  return e = l(e), e && e.replace(xt, gt).replace(St, "");
}
var Ct = y.isFinite, It = Math.min;
function Tt(e) {
  var t = Math[e];
  return function(r, n) {
    if (r = D(r), n = n == null ? 0 : It(se(n), 292), n && Ct(r)) {
      var a = (l(r) + "e").split("e"), o = t(a[0] + "e" + (+a[1] + n));
      return a = (l(o) + "e").split("e"), +(a[0] + "e" + (+a[1] - n));
    }
    return t(r);
  };
}
var F = /[\\^$.*+?()[\]{}|]/g, Et = RegExp(F.source);
function jt(e) {
  return e = l(e), e && Et.test(e) ? e.replace(F, "\\$&") : e;
}
var Pt = Tt("round"), wt = Object.defineProperty, S = (e, t) => wt(e, "name", { value: t, configurable: !0 }), H = /* @__PURE__ */ S((e) => Ot(e).replace(/[\u0300-\u036f]/g, "").toLocaleLowerCase().trim(), "normalize"), $t = /* @__PURE__ */ S((e) => H(jt(e)).match(/[\p{L}\d]+/gimu) || [], "tokenize"), At = v((e, t, r) => {
  if (!e || e.length === 0 || !t || t.length === 0)
    return [];
  const n = /\[(.*)]/;
  return e.map((a) => t.map((o) => {
    const u = I(a, o.replace(n, ""));
    if (u == null || typeof u == "function")
      return "";
    const h = I(n.exec(o), "1");
    return h ? u.map((g) => I(g, h)) : Array.isArray(u) || typeof u == "object" ? JSON.stringify(u) : u;
  }).reduce((o, u) => o + u, "")).map((a) => H(a));
}, (e, t, r) => r ?? e), Rt = /* @__PURE__ */ S((e, t, r) => {
  if (!e)
    return 0;
  const n = r.replace(/[^\p{L}\d]+/gimu, ""), a = t.sort((o, u) => u.length - o.length).reduce((o, u) => o.replace(new RegExp(u, "gm"), ""), n);
  return Pt(1 - a.length / n.length, 4);
}, "getScore");
function zt(e, t, r, n) {
  const a = $t(r);
  return At(e, t, n == null ? void 0 : n.cacheKey).reduce((u, h, g) => {
    const E = a.every((O) => h.includes(O));
    if (n != null && n.withScore) {
      const O = Rt(E, a, h);
      return u.push({
        element: e[g],
        score: O
      }), u;
    }
    return E && u.push(e[g]), u;
  }, []);
}
S(zt, "search");
export {
  zt as s
};
//# sourceMappingURL=index-Dy_WMDOX.mjs.map
